import React from 'react';
import { MenuItem, Select, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    height: '1rem',
    width: '3.0rem',
    fontSize: '0.75rem'
  },
}));

interface Props {
  value: number,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

/** 子供の人数選択のコンポーネント。 */
export const SelectChildrenNum: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  /** 子供の人数（0~20までの数値）の値の配列。 */
  const numbers = Array.from(Array(21).keys())

  return (
    <Select
      className={classes.root}
      SelectDisplayProps={{
        style: {
          padding: '10px'
        }
      }}
      onChange={props.onChange}
      value={props.value}
    >
      {
        numbers.map((n) => {
          return <MenuItem value={n} key={`children_${n}`}>{n}</MenuItem>
        })
      }
    </Select>
  );
}

export default SelectChildrenNum;
